import { render, staticRenderFns } from "./AddPromise.vue?vue&type=template&id=1be1b5ba&"
import script from "./AddPromise.vue?vue&type=script&lang=js&"
export * from "./AddPromise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports